module.exports = __webpack_public_path__ + "3705e9f62e912ae58acedd9016039b8a.MP3";